import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { HomeAway } from '@core/models/brijjsports.enums';
import { BrijjSportsStateService } from '@core/state/brijjsports-state.service';

@Component({
  selector: 'app-softball-scoring-setup',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule],
  templateUrl: './softball-scoring-setup.component.html',
  styleUrl: './softball-scoring-setup.component.scss'
})
export class SoftballScoringSetupComponent {
  private readonly fb = inject(FormBuilder);
  private readonly state = inject(BrijjSportsStateService);

  readonly teams = this.state.teams;
  readonly homeAwayOptions = [
    { value: HomeAway.Home, label: 'Home' },
    { value: HomeAway.Away, label: 'Away' },
    { value: HomeAway.Neutral, label: 'Neutral' }
  ];

  readonly form = this.fb.nonNullable.group({
    teamId: ['', Validators.required],
    opponentName: ['', Validators.required],
    homeAway: [HomeAway.Home, Validators.required],
    scheduledInnings: [7, [Validators.required, Validators.min(1), Validators.max(9)]]
  });

  readonly submitted = signal(false);

  submit(): void {
    if (this.form.invalid) return;
    this.submitted.set(true);
  }
}
